// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.existing-questions {
  padding: 25px 0 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.existing-questions .c-input-text__container {
  margin-bottom: 0;
}
.existing-questions .o-input.c-input-text__entry {
  background-color: #eee;
  padding-left: 3em;
}
.existing-questions__search {
  margin-bottom: 20px;
  padding: 0 30px;
}
.existing-questions__sorting {
  padding: 0 30px;
}
.existing-questions__sorting > div {
  padding-bottom: 7px;
}
.existing-questions__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100px;
  right: 0;
  background-color: #fff;
  box-shadow: 0px -45px 44px 1px rgba(255, 255, 255, 0.9);
}
.existing-questions__footer > div {
  display: flex;
  justify-content: space-between;
  margin-top: 26px;
  padding: 0 30px;
}
.existing-questions__list {
  padding: 0 30px 40px 30px;
  overflow-y: auto;
  flex: 0 1 auto;
}

.existing-question {
  border-bottom: 1px solid #e9e9e9;
  padding: 13px 30px 13px 0;
  height: 78px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}
.existing-question:hover {
  background-color: #f8f8f8;
}
.existing-question.selected .existing-question__right-arrow {
  background-color: #ed3293;
}
.existing-question.selected .existing-question__right-arrow .c-svg-icon {
  color: white;
}
.existing-question.selected .existing-question__name {
  color: #ed3293;
}
.existing-question__info {
  max-width: 100%;
}
.existing-question__name {
  font-size: 16px;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.existing-question__description {
  font-family: "graphik-reg", sans-serif;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.existing-question__additional-info {
  font-family: "graphik-reg", sans-serif;
  color: #a0a0a0;
}
.existing-question__right-arrow {
  position: absolute;
  right: 2px;
  top: 17px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ed3293;
  display: flex;
  justify-content: center;
  align-items: center;
}
.existing-question__right-arrow .c-svg-icon {
  color: #292929;
}
.existing-question__right-arrow .c-svg-icon svg {
  height: 8px;
  margin-left: 1px;
}`, "",{"version":3,"sources":["webpack://./src/components/configure-modals/configure-from-existing-questions/existing-questions/existing-questions.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,sBCGM;EDFN,iBAAA;AAFJ;AAKE;EACE,mBAAA;EACA,eAAA;AAHJ;AAME;EACE,eAAA;AAJJ;AAMI;EACE,mBAAA;AAJN;AAQE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,uDAAA;AANJ;AAQI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AANN;AAUE;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AARJ;;AAYA;EACE,gCAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AATF;AAWE;EACE,yBCvDM;AD8CV;AAaI;EACE,yBC9CC;ADmCP;AAaM;EACE,YAAA;AAXR;AAeI;EACE,cCtDC;ADyCP;AAiBE;EACE,eAAA;AAfJ;AAkBE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAhBJ;AAmBE;EACE,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAjBJ;AAoBE;EACE,sCAAA;EACA,cCtFM;ADoEV;AAqBE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,cCrFK;ADkEX;AAqBM;EACE,WAAA;EACA,gBAAA;AAnBR","sourcesContent":["@import '../../../../styles/variables';\n\n.existing-questions {\n  padding: 25px 0 100px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .c-input-text__container {\n    margin-bottom: 0;\n  }\n\n  .o-input.c-input-text__entry {\n    background-color: $grey-ee;\n    padding-left: 3em;\n  }\n\n  &__search {\n    margin-bottom: 20px;\n    padding: 0 30px;\n  }\n\n  &__sorting {\n    padding: 0 30px;\n\n    & > div {\n      padding-bottom: 7px;\n    }\n  }\n\n  &__footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 100px;\n    right: 0;\n    background-color: #fff;\n    box-shadow: 0px -45px 44px 1px rgba(255, 255, 255, 0.9);\n\n    & > div {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 26px;\n      padding: 0 30px;\n    }\n  }\n\n  &__list {\n    padding: 0 30px 40px 30px;\n    overflow-y: auto;\n    flex: 0 1 auto;\n  }\n}\n\n.existing-question {\n  border-bottom: 1px solid $grey-e9;\n  padding: 13px 30px 13px 0;\n  height: 78px;\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  position: relative;\n\n  &:hover {\n    background-color: $grey-f8;\n  }\n\n  &.selected {\n    .existing-question__right-arrow {\n      background-color: $pink;\n\n      .c-svg-icon {\n        color: white;\n      }\n    }\n\n    .existing-question__name {\n      color: $pink;\n    }\n  }\n\n  &__info {\n    max-width: 100%;\n  }\n\n  &__name {\n    font-size: 16px;\n    margin-bottom: 3px;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n  }\n\n  &__description {\n    font-family: \"graphik-reg\", sans-serif;\n    margin-bottom: 3px;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n  }\n\n  &__additional-info {\n    font-family: \"graphik-reg\", sans-serif;\n    color: $grey-a0;\n  }\n\n  &__right-arrow {\n    position: absolute;\n    right: 2px;\n    top: 17px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid $pink;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .c-svg-icon {\n      color: $black-29;\n\n      svg {\n        height: 8px;\n        margin-left: 1px;\n      }\n    }\n  }\n}\n","$gutter: 24px;\n$page-max-width: 934px;\n$content-max-width: 1540px;\n\n$formLabelWidth: 14rem;\n\n$grey: #7f7f7f;\n$grey-dk: #555;\n$grey-lt: #eaeaea;\n\n$grey-f8: #f8f8f8;\n$grey-f5: #f5f5f5;\n$grey-f4: #f4f4f4;\n$grey-f2: #f2f2f2;\n$grey-e9: #e9e9e9;\n$grey-e8: #e8e8e8;\n$grey-ed: #ededed;\n$grey-ee: #eee;\n$grey-d: #ddd;\n$grey-cd: #cdcdcd;\n$grey-a0: #a0a0a0;\n$grey-d4: #d4d4d4;\n$grey-b: #bbb;\n\n$pink: #ed3293;\n$pink-gradient-bottom: #c42b7a;\n$pink-semi-transparent: rgba(237, 50, 147, 0.1);\n$red: #e95456;\n$orange: #fbb820;\n$orange-dk: #ef8123;\n$yellow: #fcc600;\n$green: #98c33f;\n$green-dk: #0c9947;\n\n$base: rgba(41, 41, 41, 0.2);\n$black: #222;\n$white: #fff;\n$black-29: #292929;\n\n$mobile: 'max-width:1024px';\n$desktop: 'min-width:1025px';\n\n$xsm-dn: 'max-width:480px';\n$xsm-up: 'min-width:481px';\n\n$sm-dn: 'max-width:720px';\n$sm-up: 'min-width:721px';\n\n$md-dn: 'max-width:967px';\n$md-up: 'min-width:968px';\n\n$md2-dn: 'max-width:1099px';\n$md2-up: 'min-width:1100px';\n\n$lg-dn: 'max-width:1399px';\n$lg-up: 'min-width:1400px';\n\n$xl-dn: 'max-width:1540px';\n$xl-up: 'min-width:1541px';\n\n$short-dn: 'max-height:719px';\n$short-up: 'min-height:720px';\n\n$tall-dn: 'max-height:919px';\n$tall-up: 'min-height:920px';\n\n$editorial-margin-top: 40px;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
